/**
 * Wrap up a fetch call to reduce the boiler plate for simple internal get requests
 * @deprecated use zenoFetch
 * @param  string endpoint Required - The endpoint that we want to get the information from
 * @param  string params   Optional - Any params to be sent (as an object)
 * @return void
 */
module.exports = function(endpoint, params) {

    //convert the endpoint into a url instance
    endpoint = new URL(endpoint, location.origin);

    //add the params to the endpoint
    if (typeof params !== 'undefined') {
        endpoint.search = new URLSearchParams(params).toString();
    }

    //
    return fetch(endpoint, { 'method' : 'get' }).then((response) => response.json()).catch((error) => {
        console.error(error);
    });

}